module.exports = __webpack_public_path__ + "img/office.b77dd37a.png";